import React, { memo, useMemo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { CROSS_SELL_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { VEG_TYPE } from "@swiggy-private/cart-types";
import { FoodSymbolIconSvg } from "@cart-ui/widgets/food-symbol-icon";
import { CROSS_SELL_M2_ITEM_DETAILS_PLACEHOLDER } from "@cart-ui/constants";
import {
    BasePriceContainer,
    Description,
    FlexContainer,
    IconContainer,
    ImageContainer,
    Name,
    StyledImage,
    TextContainer,
    TextInternal,
} from "./CrossSellM2ItemDetails.style";
import { priceInRupee } from "@cart-ui/helpers/Price";

export interface CrossSellM2ItemDetailsProps {
    vegType: VEG_TYPE;
    finalPrice: number;
    basePrice: number;
    name: string;
    description?: string;
    imageId?: string;
    isSnaccStorefrontV2?: boolean;
}

const CrossSellM2ItemDetails = ({
    vegType,
    finalPrice,
    name,
    description,
    imageId,
    basePrice,
    isSnaccStorefrontV2,
}: CrossSellM2ItemDetailsProps) => {
    const accessibilityTextDetails = useMemo(() => {
        const text = `${name} ${description}`;

        return text;
    }, [name, description]);

    return (
        <div data-testid={CROSS_SELL_TEST_IDS.HALF_CARD_CONTAINER}>
            {imageId && (
                <ImageContainer
                    data-testid={CROSS_SELL_TEST_IDS.ITEM_DETAILS_ITEM_IMAGE}
                    isSnaccStorefrontV2={isSnaccStorefrontV2}
                >
                    <StyledImage
                        cloudinaryId={imageId}
                        errorFallbackSrc={CROSS_SELL_M2_ITEM_DETAILS_PLACEHOLDER}
                        fit="cover"
                        width="100%"
                        isSnaccStorefrontV2={isSnaccStorefrontV2}
                    />
                </ImageContainer>
            )}
            <TextContainer aria-label={accessibilityTextDetails} imageId={imageId}>
                <IconContainer>
                    <FoodSymbolIconSvg vegType={vegType} size={16} />
                </IconContainer>
                <TextInternal>
                    <Name
                        variant="V2.subheading1.neutral.bold"
                        color="text_High_Emphasis"
                        data-testid={CROSS_SELL_TEST_IDS.ITEM_DETAILS_ITEM_NAME}
                    >
                        {name}
                    </Name>
                    <FlexContainer>
                        {basePrice !== finalPrice && (
                            <BasePriceContainer
                                variant="V2.body1.neutral.regular"
                                color="text_Low_Emphasis"
                                data-testid={CROSS_SELL_TEST_IDS.ITEM_BASE_PRICE}
                            >
                                {`₹${priceInRupee(basePrice)}`}
                            </BasePriceContainer>
                        )}
                        <Text
                            variant="V2.subheading1.neutral.bold"
                            color="text_High_Emphasis"
                            data-testid={CROSS_SELL_TEST_IDS.ITEM_DETAILS_ITEM_PRICE}
                        >
                            {`₹${priceInRupee(finalPrice)}`}
                        </Text>
                    </FlexContainer>
                </TextInternal>
            </TextContainer>
            <Description
                variant="V2.body1.neutral.regular"
                color="text_Med_Emphasis"
                data-testid={CROSS_SELL_TEST_IDS.ITEM_DETAILS_ITEM_DESCRIPTION}
            >
                {description}
            </Description>
        </div>
    );
};

export default memo(CrossSellM2ItemDetails);
